import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SiteMapStore } from '../../site-map.store';
import { SiteMapPanel } from '../../site-map.types';

interface PanelButton {
  panel: SiteMapPanel;
  icon: string;
  tooltip: string;
  enabled: boolean;
}

@Component({
  selector: 'app-site-map-right-menu',
  standalone: true,
  templateUrl: './right-menu.component.html',
  styleUrls: ['./right-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class SiteMapRightMenuComponent {
  protected readonly store = inject(SiteMapStore);

  protected readonly panelButtons: PanelButton[] = [
    { panel: 'kpi', icon: 'assets/icon/Polygon.svg', tooltip: 'TOOLTIP.KPI', enabled: true },
    { panel: 'holes', icon: 'assets/icon/Holes.svg', tooltip: 'TOOLTIP.HOLES', enabled: true },
    { panel: 'equipment', icon: 'assets/icon/icon-park_truck.svg', tooltip: 'TOOLTIP.EQUIPMENT', enabled: true },
    { panel: 'orthophotos', icon: 'assets/icon/ortho.svg', tooltip: 'TOOLTIP.ORTHOPHOTO', enabled: true },
    { panel: 'filter', icon: 'assets/icon/Filter.svg', tooltip: 'TOOLTIP.FILTER', enabled: true },
    { panel: 'dxf', icon: 'assets/icon/Polygon.svg', tooltip: 'TOOLTIP.DXF', enabled: true },
  ];

  /**
   * Place l'infobulle du bouton survolé à gauche de celui-ci. Elle est en `position: fixed` : le menu peut défiler
   * sur une fenêtre basse, et un conteneur à défilement rognerait une infobulle positionnée dans le flux.
   */
  protected placeTooltip(event: MouseEvent): void {
    const button = (event.target as HTMLElement | null)?.closest('button');
    const tooltip = button?.querySelector<HTMLElement>('.tooltip-custom');
    if (!button || !tooltip) return;
    const rect = button.getBoundingClientRect();
    tooltip.style.left = `${rect.left}px`;
    tooltip.style.top = `${rect.top + rect.height / 2}px`;
  }

  /** Le panneau Équipement n'existe que pour le site où l'ancienne carte l'activait. */
  protected isEnabled(button: PanelButton): boolean {
    return button.panel === 'equipment' ? button.enabled && this.store.equipmentEnabled() : button.enabled;
  }
}
